import { useEffect } from 'react';
import { Route, Switch, Redirect, useLocation } from 'react-router-dom';

import Login from '../../containers/Login';
import CallScreen from '../../containers/CallScreen';
import {
  JanusInitActionCreator,
  QBInitActionCreator,
} from '../../actionCreators';
import config from '../../config';
import './styles.css';

type BaseScreenProps = {
  initJanus: JanusInitActionCreator;
  initQB: QBInitActionCreator;
};

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default (props: BaseScreenProps): JSX.Element => {
  const query = useQuery();
  const roomId = query.get('id');
  const region = query.get('region');

  useEffect(() => {
    props.initQB(config.QB);
    if (region) {
      props.initJanus({ region });
    }
  }, []);

  return (
    <Switch>
      <Route exact path="/" component={roomId && region ? CallScreen : Login} />
      <Redirect to={{ pathname: '/' }} />
    </Switch>
  );
};
